import React, { useState } from "react";
import Head from "next/head";
import { Button } from "@/components/ui/button";
import LocationsMap from "@/components/LocationsMap";

const CATEGORIES = [
  "All",
  "Pickleball",
  "Badminton",
  "Table Tennis",
  "Basketball",
  "Climbing",
  "Workshop",
  "Beach Hangout"
];

export default function Home() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  return (
    <>
      <Head>
        <title>Ensemble - Danang Activities</title>
        <meta name="description" content="Discover and join local activities in Danang - A community-driven platform for digital nomads" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ensemble-danang.com" />
        <meta property="og:title" content="Ensemble - Danang Activities" />
        <meta property="og:description" content="Discover and join local activities in Danang - A community-driven platform for digital nomads" />
        <meta property="og:image" content="/images/rect.png" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://ensemble-danang.com" />
        <meta property="twitter:title" content="Ensemble - Danang Activities" />
        <meta property="twitter:description" content="Discover and join local activities in Danang - A community-driven platform for digital nomads" />
        <meta property="twitter:image" content="/images/rect.png" />
      </Head>
      <div className="bg-background min-h-screen flex flex-col">
        <main className="flex-1 flex flex-col p-4 gap-4">
          <div className="container mx-auto max-w-7xl">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-primary mb-4">Danang Activities Map</h1>
              <p className="text-muted-foreground text-lg">
                Discover and join local activities in Danang
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-4 justify-center">
              {CATEGORIES.map((category) => (
                <Button
                  key={category}
                  variant={selectedCategory === category ? "default" : "secondary"}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </Button>
              ))}
            </div>

            <LocationsMap selectedCategory={selectedCategory} />
          </div>
        </main>
      </div>
    </>
  );
}